import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { LuArrowUpDown } from "react-icons/lu";
import "../assets/css/styles.css";
import Popover from "./popover";
import axiosInstance from "../services/axiosInstance";
import WorkflowSheet from "./workflowSheet";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import { OrderStatusEnum } from "../enums/OrderEnum";
import ViewSheetPopup from "../Popup/viewSheetPopup";
import CheckoutPopup from "../Popup/checkoutPopup";
import { GridLoader, PropagateLoader } from "react-spinners";
import SelectDriverPopup from "../Popup/selectDriverPopup";

const SortIcon = ({ sortDirection }) => {
  if (sortDirection === "asc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  if (sortDirection === "desc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  return (
    <LuArrowUpDown
      className="ml-1 !w-4 !h-5"
      style={{ color: "#EFEFEF", opacity: "1" }}
    />
  );
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#376EA4",
      color: "#FAFDFF",
      fontSize: "16px",
      fontFamily: "InterBold",
      textAlign: "left",
      padding: "15px",
      opacity: "1",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
      },
    },
    hoverStyle: {
      color: "#FAFDFF",
      opacity: "1",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: "16px",
      color: "#828282",
      padding: "6px",
      backgroundColor: "rgba(252, 252, 252, 0.5) ",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8) ",
      borderTop: "1px solid rgba(239, 239, 239, 0.8) ",
      //overflow: "hidden",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px 8px",
      },
    },
    highlightOnHoverStyle: {
      fontSize: "16px",
      color: "#202020",
      padding: "6px",
      backgroundColor: "#F4F9FF",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8)",
      borderTop: "1px solid rgba(239, 239, 239, 0.8)",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px",
      },
    },
  },
  table: {
    style: {
      display: "block",
      maxHeight: "calc(100vh - 330px)",
      height: "fit-content",
      overflowY: "auto",
      borderCollapse: "separate",
      borderSpacing: 0,
      "@media screen and (min-width: 1600px)": {
        maxHeight: "calc(100vh - 340px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 760px) and (max-width: 1250px)": {
        maxHeight: "calc(100vh - 330px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxHeight: "calc(100vh - 360px)",
        overflowX: "hidden",
      },
    },
  },
};

const formatDueDeliveryDate = (dueDeliveryDate) => {
  if (!dueDeliveryDate) return "";

  const date = new Date(dueDeliveryDate);

  // Extract day, month, hours, and minutes
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Format as dd.MM | HH:mm
  return `${day}.${month} | ${hours}:${minutes}`;
};

const CheckoutOrderTable = ({ searchTerm }) => {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [openCheckoutPopup, setOpenCheckoutPopup] = useState(false);
  const [wfSheetData, setWfSheetData] = useState({
    patientName: "",
    dentistName: "",
    geoCode: "",
    workTypeDescription: "",
    workTypeName: "",
    departments: [],
  });

  const [selectDriverPopUp, setSelectDriverPopUp] = useState(false);
  const [drivers, setDrivers] = useState([]); // Replace with your actual driver data
  const [selectedDriver, setSelectedDriver] = useState(null);

  const HandleRemovePopUp = () => setOpenPopup(false);
  const HandleCloseCheckoutPopup = () => setOpenCheckoutPopup(false);

  const handleOpenSelectDriverPopup = () => {
    setSelectDriverPopUp(true);
  };

  const handleCloseSelectDriverPopup = () => {
    setSelectDriverPopUp(false);
  };

  const handleDriverSelect = (driverId) => {
    setSelectedDriver(driverId);
    console.log("Selected driver ID:", driverId);
  };

  const selectDriver = () => {
    handleOpenSelectDriverPopup();
  };

  const handleRowSelected = (state) => {
    setSelectedRows(state.selectedRows);
  };

  const handleRowClick = (row) => {
    if (row.orderStatusId === "In Produktion") {
      return; // Prevent selection for "In Production" rows
    }
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.some((r) => r.id === row.id);
      if (isSelected) {
        // Remove row from selected rows
        return prevSelectedRows.filter((r) => r.id !== row.id);
      } else {
        // Add row to selected rows
        return [...prevSelectedRows, row];
      }
    });
  };

  const isRowSelected = (row) => {
    return selectedRows.some((r) => r.id === row.id);
  };

  const handleSendSelectedIds = async () => {
    const selectedIds = selectedRows.map((row) => row.id);
    try {
      const response = await axiosInstance.post(
        "/api/order/postCheckOutOrders",
        {
          ids: selectedIds,
        }
      );
      //console.log("API response:", response);
      if (response.isSuccess) {
        setOpenCheckoutPopup(true);
        await fetchOrders();
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.error("Error sending selected IDs:", error);
    }
  };

  const option = {
    method: "open",
    resolution: Resolution.NORMAL,
    page: {
      margin: Margin.SMALL,
      format: "A6",
      orientation: "landscape",
    },
    canvas: { mimeType: "image/png", qualityRatio: 1 },
    overrides: { canvas: { useCORS: true } },
  };

  const getTargetElement1 = () => document.getElementById("work-flow-sheet");

  const workflowSheetHandleClick = () => {
    setOpenPopup(true);
    setIsVisible(true);
    handleGeneratePDF1();
  };

  const handleGeneratePDF1 = () => {
    setTimeout(() => {
      generatePDF(getTargetElement1, option);
      setIsVisible(false);
    }, 10);
  };

  const handlePreviewWorkflowSheet = async (row) => {
    try {
      const rowId = row.id;
      const response = await axiosInstance.post(
        "/api/order/previewWorkflowSheet",
        {
          OrderId: parseInt(rowId, 10),
        }
      );
      if (response) {
        setWfSheetData({
          patientName: response.patientName,
          dentistName: response.dentistName,
          geoCode: response.geoCode,
          workTypeDescription: response.workTypeDescription,
          workTypeName: response.workTypeName,
          departments: response.departments,
        });
        workflowSheetHandleClick();
      } else {
        alert("Failed to open pdf. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    }
  };

  const columns = [
    {
      name: "Geo Code",
      selector: (row) => row.geoCode,
      width: "8%",
      sortable: true,
      sortFunction: (a, b) => {
        const numA = parseFloat(a.geoCode);
        const numB = parseFloat(b.geoCode);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return a.geoCode.localeCompare(b.geoCode);
      },
    },
    {
      name: "Praxis",
      selector: (row) => row.dentistName,
      width: "18%",
      sortable: true,
      sortFunction: (a, b) => a.dentistName.localeCompare(b.dentistName),
    },
    {
      name: "Patient",
      selector: (row) => row.patientName,
      sortable: true,
      width: "15%",
      sortFunction: (a, b) => a.patientName.localeCompare(b.patientName),
    },
    {
      name: "Arbeitsart",
      selector: (row) => row.workTypeName,
      sortable: true,
      width: "24.5%",
      sortFunction: (a, b) => a.workTypeName.localeCompare(b.workTypeName),
    },
    {
      id: "finalDeliveryDate",
      name: "Liefertermin",
      selector: (row) => new Date(row.finalDeliveryRaw), // Use raw date for sorting
      sortable: true,
      width: "12%",
      format: (row) => row.finalDelivery, // Display formatted date
    },
    {
      name: "Status",
      selector: (row) => row.orderStatusId,
      sortable: true,
      width: "12%",
      sortFunction: (a, b) => a.orderStatusId.localeCompare(b.orderStatusId),
      cell: (row) => (
        <span
          style={{
            padding: "3px 8px",
            color:
              row.orderStatusId === "In Produktion" ? "#E71852" : "#C28B01",
            backgroundColor:
              row.orderStatusId === "In Produktion" ? "#FDF3F4" : "#FDF9EA",
          }}
        >
          {row.orderStatusId}
        </span>
      ),
    },
    {
      name: "Vorschau",
      selector: (row) => row.create,
      sortable: false,
      width: "10%",
      sortFunction: (a, b) => a.create.localeCompare(b.create),
      cell: (row) => (
        <div className="gap-3 flex">
          {" "}
          {/* Added padding */}
          {/* workflow */}
          <Popover
            trigger="hover"
            content={
              <p
                className="absolute -right-7 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-10  after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit"
                style={{}}
              >
                Auftragsablauf
              </p>
            }
          >
            <button
              onClick={() => handlePreviewWorkflowSheet(row)}
              className="rounded-lg p-1.5 3xl:p-2 my-1 border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/flowchart.svg" />
            </button>
          </Popover>
        </div>
      ),
      ignoreRowClick: true,
      allowoverflow: true,
      button: true,
    },
  ];

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    // Fetch drivers from API or use static data
    const fetchDrivers = async () => {
      // Replace with your actual API endpoint
      const response = await axiosInstance.get(
        "/api/UserManagement/getAllDrivers"
      );
      setDrivers(response);
    };

    fetchDrivers();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/api/order/getCheckedInOrders");
      if (response) {
        if (Array.isArray(response)) {
          const mappedOrders = response.map((order) => {
            // const dueDeliveryDate = new Date(order.dueDeliveryDate);
            // const finalDeliveryDate = new Date(order.deliveryDate);
            // const isDue = dueDeliveryDate > finalDeliveryDate;
            return {
              id: order.orderId,
              geoCode: order.geoCode?.trim() || "",
              dentistCode: order.dentistCode || "",
              dentistName: order.dentistName || "",
              patientName: order.patientName,
              workTypeName: order.workTypeName,
              orderStatusId:
                order.orderStatusId === OrderStatusEnum.InProduction
                  ? "In Produktion"
                  : "Kontrolliert",
              finalDelivery: formatDueDeliveryDate(order.deliveryDate),
              finalDeliveryRaw: order.deliveryDate, // Store raw date for sorting
              dueDelivery: formatDueDeliveryDate(order.dueDeliveryDate),
              isDue:
                new Date(order.deliveryDate) < new Date(order.dueDeliveryDate),
              create: "",
            };
          });
          setOrders(mappedOrders);
          setSelectedRows([]);
        } else {
          setOrders([]);
          setSelectedRows([]);
        }
      } else {
        setOrders([]);
        setSelectedRows([]);
      }
    } catch (error) {
      setOrders([]);
      setSelectedRows([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredOrders = React.useMemo(() => {
    const clonedOrders = [...orders];
    return clonedOrders.filter(
      (order) =>
        order.geoCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.dentistName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.patientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.workTypeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.orderStatusId.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [orders, searchTerm]);

  return (
    <div>
      <style>
        {`
          #work-flow-sheet.hidden {
            display: none;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div>
        {loading ? (
          <div className="flex justify-center items-center min-h-60">
            <PropagateLoader color="rgb(55 110 164 / var(--tw-bg-opacity, 1))" />
          </div>
        ) : (
          <>
            <DataTable
              defaultSortFieldId="finalDeliveryDate"
              defaultSortAsc={true}
              noDataComponent={
                <div className="py-4 text-gray-500">
                  Es sind keine Datensätze zum Anzeigen vorhanden
                </div>
              }
              className=" mt-7 !rounded-xl shadow-[0_0_8px_rgba(44,99,152,0.2)] font-interRegular"
              scrollable
              scrollHeight="600px"
              columns={columns}
              data={filteredOrders}
              pagination={false}
              // selectableRows
              // onSelectedRowsChange={handleRowSelected}
              fixedHeader
              customStyles={customStyles}
              sortIcon={<SortIcon />}
              highlightOnHover={false}
              onRowClicked={handleRowClick}
              // selectableRowDisabled={(row) => row.orderStatusId === "In Production"}
              conditionalRowStyles={[
                {
                  // Condition for rows that are both due and disabled
                  when: (row) =>
                    row.isDue && row.orderStatusId === "In Produktion",
                  style: {
                    backgroundColor: "#FE725C33", // Due color
                    color: "#828282",
                    cursor: "not-allowed", // Disable interaction
                  },
                },
                {
                  // Condition for rows that are just due
                  when: (row) =>
                    row.isDue && row.orderStatusId !== "In Produktion",
                  style: {
                    backgroundColor: "#FE725C33", // Due color
                    color: "#828282",
                  },
                },
                {
                  // Condition for rows that are selected
                  when: (row) => isRowSelected(row),
                  style: {
                    backgroundColor: "#cce5ff",
                    color: "#004085",
                  },
                },
                {
                  // Condition for rows that are disabled but not due
                  when: (row) =>
                    row.orderStatusId === "In Produktion" && !row.isDue,
                  style: {
                    cursor: "not-allowed",
                    // Disabled color
                    color: "#a9a9a9",
                  },
                },
              ]}
            />
            <div className="flex flex-row justify-between gap-3 sm:gap-4 mt-4">
              <button
                className={`w-1/2 sm:w-auto bg-white border text-blue-700 text-lg sm:text-2xl xl:!text-base 3xl:!text-2xl uppercase ${
                  selectedRows.length > 0
                    ? "border-blue hover:bg-blue-100 hover:border-blue-800"
                    : "border-gray-300 bg-gray-100 text-gray-400 cursor-not-allowed"
                } font-robotoBold py-2 px-2 sm:px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in`}
                type="button"
                onClick={handleSendSelectedIds}
                disabled={selectedRows.length === 0}
                style={{ order: 1 }}
              >
                Ausbuchen
              </button>
              <button
                className={`w-1/2 sm:w-auto bg-blue text-lg sm:text-2xl xl:!text-base 3xl:!text-2xl uppercase border ${
                  selectedRows.length > 0
                    ? "border-blue hover:bg-blue-800 hover:border-blue-800 text-white"
                    : "border-gray-300 bg-gray-300 text-gray-500 cursor-not-allowed"
                } font-robotoBold py-2 px-2 sm:px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in`}
                type="button"
                onClick={selectDriver}
                disabled={selectedRows.length === 0}
                style={{ order: 2 }}
              >
                Fahrer wählen
              </button>
            </div>
          </>
        )}
      </div>

      {/* modal popup */}
      <ViewSheetPopup openPopUp={openPopup} closePopUp={HandleRemovePopUp} />
      <CheckoutPopup
        openPopUp={openCheckoutPopup}
        closePopUp={HandleCloseCheckoutPopup}
      />

      {/* SelectDriverPopup */}
      <SelectDriverPopup
        openPopUp={selectDriverPopUp}
        closePopUp={handleCloseSelectDriverPopup}
        fetchOrders={fetchOrders}
        drivers={drivers}
        onDriverSelect={handleDriverSelect}
        selectedRows={selectedRows}
      />

      {/* work flow sheet */}
      <WorkflowSheet
        wfSheetData={wfSheetData}
        formatDueDeliveryDate={formatDueDeliveryDate}
        isVisible={isVisible}
      />
    </div>
  );
};

export default CheckoutOrderTable;
